import MultipleChoiceV1 from "../../../../components/form_builder/elements/multiple_choice/MultipleChoiceV1.vue";
import { validateRequired } from "../../../../helpers/validation";

export default {
  componentName: "fb-multiple-choice-v1",
  component: MultipleChoiceV1,
  defaultAttrs: {
    properties: {
      label: "Label",
      options: [],
      description: "",
      value: [],
      required: false,
      hidden: false,
      showInline: false,
      columnsCount: 1,
      style: {},
      eFormEditable: true
    }
  },
  gridAttrs: {
    type: "template",
    width: 120,
    template: ({ value }) =>
      value ? (value.join ? value.join(", ") : value) : ""
  },
  getValueReport: value => {
    return value ? (value.join ? value.join(", ") : "") : "";
  },
  validate: ({ value, properties }) => {
    const errors = [];
    if (properties.required && !validateRequired(value.join(", ")))
      errors.push("This field is required");
    return errors;
  }
};
